var map = {
	"./ChannelsHigh.svg": "169a",
	"./Customer.svg": "7fea",
	"./DashboardHigh.svg": "ddc1",
	"./GSTHigh.svg": "0c4f",
	"./InventoryHigh.svg": "5e1c",
	"./OrderHigh.svg": "7656",
	"./RemittancesHigh.svg": "cd1f",
	"./ReportsHigh.svg": "a765",
	"./ShipmentHigh.svg": "6305",
	"./UserHigh.svg": "657b",
	"./warehouseHigh.svg": "1152"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba45";